module.exports = __webpack_public_path__ + "media/images/beauty/main_image1-0eaf3daa7de7d3656147edf5772f94c3.jpg";